export default __webpack_public_path__ + "static/media/m_r.a42766ce.wav";